import * as React from "react";

function SvgOffice({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M2 21.75a.75.75 0 01-.102-1.493L2 20.25h.25V7.913c0-.87.668-1.584 1.52-1.657l.143-.006H7.25V4a1.75 1.75 0 011.606-1.744L9 2.25h6a1.75 1.75 0 011.744 1.606L16.75 4v2.25h3.337c.87 0 1.584.668 1.657 1.52l.006.143V20.25H22a.75.75 0 01.102 1.493L22 21.75H2zm5.25-14H3.913a.164.164 0 00-.155.111l-.008.052V20.25h3.5v-3.5H5.5a.75.75 0 01-.102-1.493l.102-.007h1.75v-1.5H5.5a.75.75 0 01-.102-1.493l.102-.007h1.75v-1.5H5.5a.75.75 0 01-.102-1.493L5.5 9.25h1.75v-1.5zm7.75-4H9a.25.25 0 00-.243.193L8.75 4v16.25h2.5V19a.75.75 0 011.493-.102l.007.102v1.25h2.5V4a.25.25 0 00-.193-.243L15 3.75zm5.087 4H16.75v1.5h1.75a.75.75 0 01.102 1.493l-.102.007h-1.75v1.5h1.75a.75.75 0 01.102 1.493l-.102.007h-1.75v1.5h1.75a.75.75 0 01.102 1.493l-.102.007h-1.75v3.5h3.5V7.913a.164.164 0 00-.111-.155l-.052-.008zm-6.587 7.5a.75.75 0 01.102 1.493l-.102.007h-3a.75.75 0 01-.102-1.493l.102-.007h3zm0-3a.75.75 0 01.102 1.493l-.102.007h-3a.75.75 0 01-.102-1.493l.102-.007h3zm0-3a.75.75 0 01.102 1.493l-.102.007h-3a.75.75 0 01-.102-1.493l.102-.007h3zm0-3a.75.75 0 01.102 1.493l-.102.007h-3a.75.75 0 01-.102-1.493l.102-.007h3z"
        />
      </g>
    </svg>
  );
}

export default SvgOffice;
